import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const ModuleAPI = {
	list: async (search) => {
		const params = search ? {search} : {};
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Modules",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Modules/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Modules",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Modules/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Modules/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getRoles: async (moduleId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Modules/" + moduleId + "/roles",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addRole: async (moduleId, playerRoleId) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Modules/roles",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data: {moduleId, playerRoleId},
		});

		return response.data;
	},
	removeRole: async (moduleId, playerRoleId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Modules/" + moduleId + "/roles/" + playerRoleId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
